import React from 'react';
import { Table } from '@tanstack/react-table';
import type { DataTableRow, TableAction } from '../types';
import { HierarchicalTableBody } from './hierarchical-table-body';
import { SimpleTableBody } from './simple-table-body';

interface TableBodyProps<T extends DataTableRow> {
  table: Table<T>;
  selectable?: boolean;
  actions?: TableAction<T>[];
  hierarchical?: boolean;
  expandedRows?: Set<string>;
  onRowExpand?: (rowId: string, expanded: boolean) => void;
  getRowChildren?: (row: T) => T[];
  getRowLevel?: (row: T) => number;
  renderExpandIcon?: (row: T, isExpanded: boolean) => React.ReactNode;
  rowClassName?: (row: T) => string;
  isRowSelectable?: (row: T) => boolean;
  renderGroupRow?: (row: T, isExpanded: boolean, onToggle: () => void) => React.ReactNode;
  isGroupRow?: (row: T) => boolean;
}

export function DataTableBody<T extends DataTableRow>({
  table,
  selectable = false,
  actions = [],
  hierarchical = false,
  expandedRows,
  onRowExpand,
  getRowChildren,
  getRowLevel,
  renderExpandIcon,
  rowClassName,
  isRowSelectable,
  renderGroupRow,
  isGroupRow
}: TableBodyProps<T>) {
  if (hierarchical) {
    return (
      <HierarchicalTableBody
        table={table}
        selectable={selectable}
        actions={actions}
        expandedRows={expandedRows}
        onRowExpand={onRowExpand}
        getRowChildren={getRowChildren}
        getRowLevel={getRowLevel}
        renderExpandIcon={renderExpandIcon}
        rowClassName={rowClassName}
        isRowSelectable={isRowSelectable}
        renderGroupRow={renderGroupRow}
        isGroupRow={isGroupRow}
      />
    );
  }

  return <SimpleTableBody table={table} selectable={selectable} actions={actions} />;
}
